<p-sidebar [(visible)]="walkInDrawerVisible"
		   position="right"
		   [modal]="true"
		   [dismissible]="!walkInSubmitting"
		   [closeOnEscape]="!walkInSubmitting"
		   [showCloseIcon]="false"
		   [style]="walkInDrawerPanelStyle"
		   styleClass="ccb-walk-in-drawer"
		   (onHide)="onDrawerHide()">
	<ng-template pTemplate="header">
		<div class="ccb-walkin-header">
			<button type="button"
					class="ccb-walkin-close"
					[disabled]="walkInSubmitting"
					(click)="close()">
				<i class="pi pi-times"></i>
			</button>
			<div class="ccb-walkin-header__top">
				<div>
					<h3>New Walk-in Booking</h3>
					<p>Book a passenger on the spot - confirms instantly into ConneX inventory.</p>
				</div>
			</div>

			<div class="ccb-walkin-steps">
				<div class="ccb-walkin-step" [class.is-active]="walkInStep === 1" [class.is-done]="walkInStep > 1">
					<span>1</span>
					<strong>Route &amp; Slot</strong>
				</div>
				<div class="ccb-walkin-step__line"></div>
				<div class="ccb-walkin-step" [class.is-active]="walkInStep === 2" [class.is-done]="walkInStep > 2">
					<span>2</span>
					<strong>Passenger</strong>
				</div>
				<div class="ccb-walkin-step__line"></div>
				<div class="ccb-walkin-step" [class.is-active]="walkInStep === 3">
					<span>3</span>
					<strong>Review</strong>
				</div>
			</div>
		</div>
	</ng-template>

	<div class="ccb-walkin-content">
		<div *ngIf="walkInStep === 1" class="ccb-walkin-section">
			<div class="ccb-walkin-section__title">
				<h4>Route &amp; Schedule</h4>
				<p>Choose the trip the passenger needs.</p>
			</div>

			<label class="ccb-walkin-field">
				<span>Route*</span>
				<p-dropdown [options]="walkInRouteOptions"
							optionLabel="Name"
							[showClear]="true"
							[loading]="walkInLoadingRoutes"
							placeholder="Select a route"
							[(ngModel)]="walkInForm.route"
							(ngModelChange)="onWalkInRouteChange()"></p-dropdown>
			</label>

			<div *ngIf="walkInShowRouteFilters" class="ccb-walkin-route-filters">
				<div class="ccb-walkin-grid ccb-walkin-grid--2">
					<label class="ccb-walkin-field">
						<span>Pickup Zone*</span>
						<p-dropdown [options]="walkInPickupZoneOptions"
									optionLabel="Name"
									[showClear]="true"
									placeholder="Select pickup zone"
									[(ngModel)]="walkInForm.pickupZone"
									(ngModelChange)="onWalkInPickupZoneChange()"></p-dropdown>
					</label>
					<label class="ccb-walkin-field">
						<span>Drop Zone*</span>
						<p-dropdown [options]="walkInDropoffZoneOptions"
									optionLabel="Name"
									[showClear]="true"
									placeholder="Select drop zone"
									[(ngModel)]="walkInForm.dropoffZone"
									(ngModelChange)="onWalkInDropoffZoneChange()"></p-dropdown>
					</label>
				</div>

				<label class="ccb-walkin-field">
					<span>Date*</span>
					<p-calendar [(ngModel)]="walkInForm.date"
								[showIcon]="true"
								[minDate]="walkInMinDate"
								[readonlyInput]="false"
								panelStyleClass="ccb-walkin-calendar-panel"
								dateFormat="mm/dd/yy"
								(onSelect)="onWalkInDateChange()"></p-calendar>
				</label>
			</div>

			<div *ngIf="walkInShowRouteFilters" class="ccb-walkin-slots">
				<div class="ccb-walkin-slots__head">
					<strong>Departure Time*</strong>
					<span *ngIf="walkInLoadingSlots">Loading slots…</span>
				</div>

				<div *ngIf="!walkInLoadingSlots && walkInSlots.length === 0" class="ccb-walkin-slots__empty">
					No slots match the selected filters.
				</div>

				<div class="ccb-walkin-slots__grid">
					<button type="button"
							class="ccb-walkin-slot-card"
							*ngFor="let slot of walkInSlots"
							[class.is-selected]="isWalkInSlotSelected(slot)"
							[class.is-full]="!slot.IsAvailable"
							[disabled]="walkInLoadingSlots || !slot.IsAvailable"
							(click)="onWalkInSlotSelect(slot)">
						<div class="ccb-walkin-slot-card__main">
							<strong>{{ slotOptionTime(slot) }}</strong>
							<span>{{ slotOptionFare(slot) }}</span>
						</div>
						<span class="ccb-walkin-slot-card__status"
							  [ngClass]="walkInSlotStatusClass(slot)">
							{{ walkInSlotStatusLabel(slot) }}
						</span>
					</button>
				</div>

				<p class="ccb-walkin-slots__hint">Slots in red are full. Pick another time or another date.</p>
			</div>
		</div>

		<div *ngIf="walkInStep === 2" class="ccb-walkin-section">
			<div class="ccb-walkin-section__title">
				<h4>Passenger</h4>
				<p>Capture who's travelling and how many.</p>
			</div>

			<div class="ccb-walkin-grid ccb-walkin-grid--2">
				<label class="ccb-walkin-field">
					<span>Customer name*</span>
					<input type="text"
						   pInputText
						   [(ngModel)]="walkInForm.guestName"
						   (blur)="walkInGuestNameTouched = true"
						   placeholder="Nathan Ocampo" />
					<small class="ccb-walkin-field-error" *ngIf="walkInGuestNameError">{{ walkInGuestNameError }}</small>
				</label>
				<label class="ccb-walkin-field">
					<span>Mobile Number*</span>
					<p-autoComplete [(ngModel)]="walkInCustomerAutocompleteValue"
									[suggestions]="walkInCustomerMatches"
									field="Phone"
									[forceSelection]="false"
									[showClear]="true"
									[delay]="400"
									[minLength]="7"
									[dropdown]="false"
									placeholder="+639123456789"
									(completeMethod)="searchWalkInCustomersByPhone($event)"
									(ngModelChange)="onWalkInCustomerAutocompleteChange($event)"
									(onSelect)="onWalkInCustomerAutocompleteSelect($event)"
									(onClear)="onWalkInCustomerAutocompleteClear()"
									(onBlur)="onWalkInGuestPhoneBlur()">
						<ng-template let-customer pTemplate="item">
							<div class="ccb-walkin-customer-option">
								<strong>{{ customer.UserName }}</strong>
								<span>{{ customer.Phone }}</span>
							</div>
						</ng-template>
					</p-autoComplete>
					<small class="ccb-walkin-field-hint" *ngIf="walkInCustomerLookupLoading">Checking number…</small>
					<small class="ccb-walkin-field-error" *ngIf="walkInGuestPhoneError">{{ walkInGuestPhoneError }}</small>
				</label>
			</div>

			<div class="ccb-walkin-grid ccb-walkin-grid--3">
				<label class="ccb-walkin-field">
					<span>Passenger*</span>
					<div class="ccb-counter">
						<button type="button" (click)="adjustWalkInPax(-1)">−</button>
						<strong>{{ walkInForm.paxCount }}</strong>
						<button type="button" (click)="adjustWalkInPax(1)">+</button>
					</div>
				</label>
				<label class="ccb-walkin-field">
					<span>Vehicles*</span>
					<div class="ccb-counter ccb-counter--disabled">
						<button type="button" disabled>−</button>
						<strong>{{ walkInForm.vehicleCount }}</strong>
						<button type="button" disabled>+</button>
					</div>
				</label>
				<label class="ccb-walkin-field">
					<span>Vehicle Type*</span>
					<input type="text" pInputText value="SUV - BYD eMax 7" disabled />
				</label>
			</div>

			<p class="ccb-walkin-capacity" *ngIf="walkInSelectedSlot">
				{{ walkInSelectedSlot.VehicleCapacity }} car(s) available in slot · Max {{ walkInSelectedSlot.MaxPassengersPerVehicle }} pax
			</p>
		</div>

		<div *ngIf="walkInStep === 3" class="ccb-walkin-section ccb-walkin-review">
			<h4>Trip Summary</h4>
			<div class="ccb-review-grid">
				<div>
					<strong>Route</strong>
					<span>{{ walkInTripRouteLabel }}</span>
				</div>
				<div>
					<strong>Schedule</strong>
					<span>{{ walkInScheduleLabel }}</span>
				</div>
				<div>
					<strong>Pickup</strong>
					<span>{{ walkInPickupLabel }}</span>
				</div>
				<div>
					<strong>Drop-off</strong>
					<span>{{ walkInDropoffLabel }}</span>
				</div>
				<div>
					<strong>Passenger</strong>
					<span>{{ walkInForm.paxCount }} pax</span>
				</div>
				<div>
					<strong>Vehicle</strong>
					<span>{{ walkInForm.vehicleCount }} x SUV - BYD eMax 7</span>
				</div>
			</div>

			<div class="ccb-review-customer">
				<div class="ccb-review-avatar">{{ walkInPassengerInitials }}</div>
				<div>
					<strong>{{ walkInForm.guestName || '—' }}</strong>
					<span>{{ walkInForm.guestPhone || '—' }}</span>
				</div>
				<em>{{ walkInPassengerTypeLabel }}</em>
			</div>

			<div class="ccb-fare-card">
				<h4>Fare</h4>
				<div>
					<span>Base fare x {{ walkInForm.vehicleCount }}</span>
					<strong>{{ walkInBaseFareLabel }}</strong>
				</div>
				<hr />
				<div class="ccb-fare-card__total">
					<span>Total (Book)</span>
					<strong>{{ walkInBookTotalLabel }}</strong>
				</div>
				<p>Toll is already included in the base fare.</p>
			</div>

			<div class="ccb-dispatch-note">
				<strong>Need a driver right away?</strong>
				<span>Immediate Dispatch assigns the nearest available driver right away. Total with walk-in premium: {{ walkInTotalFareLabel }}.</span>
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<div class="ccb-walkin-footer">
			<p>Slot inventory will decrement by 1 on booking.</p>
			<div class="ccb-walkin-footer__actions">
				<button type="button"
						pButton
						class="ccb-walkin-btn ccb-walkin-btn--secondary"
						label="Back"
						*ngIf="walkInStep > 1"
						(click)="backWalkIn()"></button>
				<button type="button"
						pButton
						class="ccb-walkin-btn ccb-walkin-btn--primary"
						label="Continue"
						icon="pi pi-angle-right"
						iconPos="right"
						*ngIf="walkInStep < 3"
						(click)="continueWalkIn()"></button>
				<button type="button"
						pButton
						class="ccb-walkin-btn ccb-walkin-btn--primary"
						label="Book"
						*ngIf="walkInStep === 3"
						[disabled]="!walkInCanBookScheduled || walkInSubmitting"
						(click)="openWalkInConfirm(deliveryBookingTypeEnum.WalkIn)"></button>
				<button type="button"
						pButton
						class="ccb-walkin-btn ccb-walkin-btn--dispatch"
						label="Book + Immediate Dispatch"
						icon="pi pi-bolt"
						*ngIf="walkInStep === 3"
						[disabled]="!walkInCanSubmit || walkInSubmitting"
						(click)="openWalkInConfirm(deliveryBookingTypeEnum.WalkInImmediateDispatch)"></button>
			</div>
		</div>
	</ng-template>
</p-sidebar>

<p-dialog [(visible)]="walkInConfirmVisible"
		  [modal]="true"
		  [draggable]="false"
		  [resizable]="false"
		  [closable]="false"
		  styleClass="ccb-dispatch-dialog"
		  [style]="{ width: '648px' }">
	<div class="ccb-dispatch-dialog__head">
		<i class="pi"
		   [ngClass]="walkInConfirmIconClass"></i>
		<div>
			<h3>{{ walkInConfirmTitle }}</h3>
			<p>{{ walkInConfirmBody }}</p>
		</div>
	</div>

	<div class="ccb-fare-card ccb-fare-card--dialog">
		<h4>Fare</h4>
		<div>
			<span>{{ walkInConfirmBaseFareLabel }}</span>
			<strong>{{ walkInBaseFareLabel }}</strong>
		</div>
		<div *ngIf="isWalkInImmediateDispatchConfirm">
			<span>Walk-in premium</span>
			<strong>{{ walkInPremiumLabel }}</strong>
		</div>
		<hr />
		<div class="ccb-fare-card__total">
			<span>Total</span>
			<strong>{{ walkInConfirmTotalLabel }}</strong>
		</div>
		<p>Toll is already included in the base fare.</p>
	</div>

	<label class="ccb-cash-confirm">
		<p-checkbox [(ngModel)]="walkInCashCollected" [binary]="true"></p-checkbox>
		<span>
			<strong>I have collected {{ walkInConfirmTotalLabel }} from the passenger.</strong>
			<small>Required before creating this booking.</small>
		</span>
	</label>

	<ng-template pTemplate="footer">
		<button type="button"
				pButton
				class="ccb-walkin-btn ccb-walkin-btn--secondary"
				label="Cancel"
				[disabled]="walkInSubmitting"
				(click)="cancelWalkInConfirm()"></button>
		<button type="button"
				pButton
				class="ccb-walkin-btn ccb-walkin-btn--primary"
				label="Confirm Booking"
				[loading]="walkInSubmitting"
				[disabled]="!walkInCashCollected || walkInSubmitting"
				(click)="confirmWalkInBooking()"></button>
	</ng-template>
</p-dialog>
